<template>
  <div class="growth-wizard insights-onboarding-wizard streamlined-getting-started">
    <template v-if="showWelcomeScreen">
      <div id="growth-wizard-welcome-screen">
        <div
          class="title"
          data-testid="insights-onboarding-welcome-title"
        >
          🚀 Welcome to Hubstaff Insights!
        </div>
        <div class="subtitle">Learn about one of our most powerful tools for monitoring your team.</div>
        <img
          :src="INSIGHTS_ONBOARDING_WELCOME_IMG"
          alt="Welcome to Hubstaff Insights"
        />
        <AppButton
          type="primary"
          class="continue-button"
          data-testid="insights-onboarding-welcome-button"
          @click="hideWelcomeScreen"
        >
          Get started
        </AppButton>
      </div>
    </template>
    <template v-else-if="showCompletionScreen">
      <GrowthWizardCompletionScreen
        :organization="organization"
        :completion-screen-data="completionScreen.data"
        :completion-screen-template="completionScreen.template"
      />
    </template>
    <template v-else>
      <div
        id="growth-wizard-section-steps"
        class="growth-wizard-section"
      >
        <div id="growth-wizard-header">
          <p class="title">🚀 Let's set up Insights!</p>
        </div>
        <div class="gs-steps wizard-progress-bar">
          <div class="gs-progress-bar">
            <div
              class="gs-progress"
              :style="{ width: `${overallProgressPercentage}%` }"
            ></div>
          </div>
        </div>
      </div>
      <div
        v-loading="loading"
        class="loading static-curtain"
      />
      <div
        v-if="substepData"
        id="growth-wizard-section-substeps"
        class="growth-wizard-section"
      >
        <component
          :is="currentSubstepComponent"
          class="substep-component"
          v-bind="getSubstepProps()"
          v-on="getSubstepEvents()"
        />
      </div>

      <div
        v-if="substepData"
        class="streamlined-bottom-bar"
      >
        <div
          class="cta-wrapper"
          :class="ctaWrapperClass"
        >
          <AppButton
            v-if="!isFirstSubstep"
            class="continue-button hs-btn-outline-gray"
            @click="returnToPreviousStep"
          >
            <i class="hi hi-16 hi-left-arrow"></i>
            Back
          </AppButton>

          <AppButton
            type="primary"
            class="continue-button"
            :disabled="!nextStepAllowed"
            data-testid="insights-onboarding-continue-button"
            @click="continueToNextStep"
          >
            {{ nextStepText }}
          </AppButton>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { INSIGHTS_ONBOARDING_WELCOME_IMG } from '~/rails_assets';
import { INSIGHTS_ONBOARDING_SUBSTEP_COMPONENTS } from '~/components/growth_wizard/insights_onboarding/substeps/mappings';
import { InsightsOnboardingResource } from '~/resources';
import WizardBaseMixin from '~/mixins/GrowthWizard/WizardBaseMixin';
import GrowthWizardCompletionScreen from '~/components/growth_wizard/completion_screens/GrowthWizardCompletionScreen.vue';

export default {
  name: 'InsightsOnboardingIndex',
  components: {
    GrowthWizardCompletionScreen,
  },
  mixins: [WizardBaseMixin],
  props: {
    wizardFinished: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    INSIGHTS_ONBOARDING_WELCOME_IMG,
    substepsWithFinishedHandlers: [],
    userDismissedWelcome: false,
  }),
  computed: {
    ctaWrapperClass() {
      return this.isFirstSubstep ? 'justify-center' : 'justify-between';
    },
    substepComponentsMap() {
      return INSIGHTS_ONBOARDING_SUBSTEP_COMPONENTS;
    },
    resourceAPI() {
      return InsightsOnboardingResource;
    },
    nextStepText() {
      return this.wizardFinished || !this.nextSubstep ? 'Finish ✔' : 'Continue ➜';
    },
    anySubstepCompleted() {
      return this.allSubsteps.some((substep) => substep.status === 'completed');
    },
    showWelcomeScreen() {
      return !this.userDismissedWelcome && this.isFirstSubstep && !this.anySubstepCompleted;
    },
  },
  beforeMount() {
    this.getSubstepData();
  },
  methods: {
    hideWelcomeScreen() {
      this.userDismissedWelcome = true;
    },
  },
};
</script>
